import React, { useEffect, useState } from 'react';
import '../../assets/sass/uiV3/component/_myActivity.scss';
import { Accordion, ProgressBar as BootstrapProgressBar } from 'react-bootstrap';
import { Skeleton } from '../Skeleton';

export const MyActivitySkeleton = () => {
  return (
    <>
      <div className="clr_v3_myActivity__container d-flex flex-wrap mt-3 mt-sm-4">
        <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
          <div className={`d-flex flex-column gap-2 `}>
            <div className="d-flex justify-content-between">
              <span className="fs-14 fw-normal">
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
              <span className={`fs-14 fw-semibold text-primary`}>
                {' '}
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
            </div>
            <BootstrapProgressBar now={0} />
          </div>
        </div>
        <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
          <div className={`d-flex flex-column gap-2 `}>
            <div className="d-flex justify-content-between">
              <span className="fs-14 fw-normal">
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
              <span className={`fs-14 fw-semibold text-primary`}>
                {' '}
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
            </div>
            <BootstrapProgressBar now={0} />
          </div>
        </div>
        <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
          <div className={`d-flex flex-column gap-2 `}>
            <div className="d-flex justify-content-between">
              <span className="fs-14 fw-normal">
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
              <span className={`fs-14 fw-semibold text-primary`}>
                {' '}
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
            </div>
            <BootstrapProgressBar now={0} />
          </div>
        </div>
        <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
          <div className={`d-flex flex-column gap-2 `}>
            <div className="d-flex justify-content-between">
              <span className="fs-14 fw-normal">
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
              <span className={`fs-14 fw-semibold text-primary`}>
                {' '}
                <Skeleton height={15} width={15} variant={'circular'} />
              </span>
            </div>
            <BootstrapProgressBar now={0} />
          </div>
        </div>
      </div>

      <div className="bg-body p-3 rounded-3 d-flex justify-content-between align-items-center mt-20">
        <h4 className="fs-16 text-dark fw-medium">Points Earned</h4>
        <h2 className="fs-2 text-black fw-semibold">
          <Skeleton width={50} />
        </h2>
      </div>
    </>
  );
};
